import React, { createContext, ReactElement } from 'react';
import { useGetLayoutContextValues } from './LayoutContextProvider.hooks';
import { LayoutContextContent } from './LayoutContextProvider.types';

interface LayoutContextProps {
  children: React.ReactNode;
}

const LayoutContext = createContext<LayoutContextContent>(
  {} as LayoutContextContent,
);

export const LayoutContextProvider = ({
  children,
}: LayoutContextProps): ReactElement => {
  const rebrandContextValues = useGetLayoutContextValues();

  return (
    <LayoutContext.Provider value={rebrandContextValues}>
      {children}
    </LayoutContext.Provider>
  );
};

export { LayoutContext };
